<template>
    <div>
        <div v-if="! isTasksTableVisible" class="columns is-multiline">
            <div class="column is-12-tablet is-3-desktop">
                <nav class="panel applications-nav is-flex-touch is-multiline">
                  <router-link :to="getTabRoute('filings')" :class="['panel-block', {'is-active': currentTab === 'filings'}]">Filings</router-link>
                  <router-link :to="getTabRoute('violations')" :class="['panel-block', {'is-active': currentTab === 'violations'}]">Violations</router-link>
                  <router-link :to="getTabRoute('determination')" :class="['panel-block', {'is-active': currentTab === 'determination'}]">Determination</router-link>
                  <router-link :to="getTabRoute('tracking')" :class="['panel-block', {'is-active': currentTab === 'tracking'}]">Tracking/IBM#</router-link>
                  <router-link :to="getTabRoute('miscServices')" :class="['panel-block', {'is-active': currentTab === 'miscServices'}]">Misc. Services</router-link>
                  <router-link :to="getTabRoute('dotPermits')" :class="['panel-block', {'is-active': currentTab === 'dotPermits'}]">DOT Permits</router-link>
                  <router-link :to="getTabRoute('permits')" :class="['panel-block', {'is-active': currentTab === 'permits'}]">Permits</router-link>
                  <router-link :to="getTabRoute('afterHoursPermit')" :class="['panel-block', {'is-active': currentTab === 'afterHoursPermit'}]">After Hours Permit</router-link>
                  <router-link :to="getTabRoute('certificateOfOccupancy')" :class="['panel-block', {'is-active': currentTab === 'certificateOfOccupancy'}]">Certificate of Occupancy</router-link>
                  <router-link :to="getTabRoute('inspections')" :class="['panel-block', {'is-active': currentTab === 'inspections'}]">Inspections</router-link>
                </nav>
            </div>
            <div v-if="currentTab === 'filings'" class="column is-12-tablet is-9-desktop">
                <filings @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'violations'" class="column is-12-tablet is-9-desktop">
                <violations @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'determination'" class="column is-12-tablet is-9-desktop">
                <determinations @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'tracking'" class="column is-12-tablet is-9-desktop">
                <trackings @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'miscServices'" class="column is-12-tablet is-9-desktop">
                <misc-services @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'dotPermits'" class="column is-12-tablet is-9-desktop">
                <dot-permits @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'permits'" class="column is-12-tablet is-9-desktop">
                <permits @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'afterHoursPermit'" class="column is-12-tablet is-9-desktop">
                <after-hours-permits @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'certificateOfOccupancy'" class="column is-12-tablet is-9-desktop">
                <occupancy-certificates @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>

            <div v-if="currentTab === 'inspections'" class="column is-12-tablet is-9-desktop">
                <inspections @application-selected="showApplicationTasks" @task-create="handleTaskCreate" />
            </div>
        </div>

        <template v-else-if="isTasksTableVisible && tasks">
            <div class="columns">
                <div class="column between-center">
                    <h4 class="title is-4" style="border: none; margin: 0; padding: 0;">{{ name }}</h4>
                    <div class="field is-grouped">
                        <p v-if="isDeleteSelectedButtonVisible" class="control">
                            <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                        </p>
                        <p class="control">
                            <button @click="handleTaskCreate(applicationType, applicationId)" class="button is-info" >
                                <span class="icon"><i class="icm-new"></i></span>
                                <span>Create Task</span>
                            </button>
                        </p>
                        <p class="control">
                            <button @click="isTasksTableVisible = false" class="button is-info" >
                                <span>Back To Applications</span>
                            </button>
                        </p>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <o-table
                        class="is-responsive is-responsive-desktop"
                        :data="tasks"
                        :bordered="table.bordered"
                        :striped="table.striped"
                        :narrowed="table.narrowed"
                        :checkable="table.checkable"
                        :mobile-cards="table.mobileCards"
                        :paginated="table.paginated"
                        :pagination-simple="table.paginationSimple"
                        :per-page="table.perPage"
                        :default-sort-direction="table.defaultSortDirection"
                        :default-sort="table.defaultSort"

                        :selected.sync="selected"
                        :checked-rows="checkedRows"
                        @update:checkedRows="$event => checkedRows = $event"
                    >
                        <template>

                            <o-table-column #default="{ row }" field="title" label="Title" sortable>
                                <router-link :to="projectTaskRoute(row)">{{ $filters.valueOrDefault(row.title) }}</router-link>
                            </o-table-column>

                            <o-table-column #default="{ row }" field="due_date" label="Due Date" sortable>
                                {{ $filters.date(moment(row.due_date)) }}
                            </o-table-column>

                            <o-table-column #default="{ row }" field="date_requested" label="Date Requested" sortable>
                                {{ $filters.date(moment(row.date_requested)) }}
                            </o-table-column>

                            <o-table-column #default="{ row }" field="date_sent" label="Date Sent" sortable>
                                {{ $filters.date(moment(row.date_sent)) }}
                            </o-table-column>

                            <o-table-column #default="{ row }" field="date_received" label="Date Received" sortable>
                                {{ $filters.date(moment(row.date_received)) }}
                            </o-table-column>

                            <o-table-column #default="{ row }" label="">
                                <o-dropdown hoverable position="bottom-left" class="table-actions">
                                    <button class="button" slot="trigger">
                                        <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                    </button>
                                    <o-dropdown-item has-link><a @click.prevent="openReminderModal(row)">Set Reminder</a></o-dropdown-item>
                                    <o-dropdown-item has-link><router-link :to="projectTaskRoute(row)">View</router-link></o-dropdown-item>
                                    <o-dropdown-item has-link><a @click.prevent="handleTaskEdit(row)">Edit</a></o-dropdown-item>
                                </o-dropdown>
                            </o-table-column>
                        </template>

                        <div slot="empty" class="has-text-centered">
                            No tasks for this application
                        </div>
                    </o-table>
                </div>
            </div>
        </template>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="currentTask.id" reference-type="task"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCreateTaskModalActive" has-modal-card>
            <create-task-modal :item="newTask" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isEditTaskModalActive" has-modal-card>
            <edit-task-modal :item="editTask" />
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from './../../../mixins/Table'

    import OccupancyCertificates from './applications/OccupancyCertificates'
    import AfterHoursPermits from './applications/AfterHoursPermits'
    import Determinations from './applications/Determinations'
    import MiscServices from './applications/MiscServices'
    import Inspections from './applications/Inspections'
    import Violations from './applications/Violations'
    import DotPermits from './applications/DotPermits'
    import Trackings from './applications/Trackings'
    import Filings from './applications/Filings'
    import Permits from './applications/Permits'

    import CreateTaskModal from './applications/CreateTaskModal'
    import EditTaskModal from './../../tasks/show/EditModal'
    import { getApplicationTabNameByType } from './../../../utils'

    export default {
        mixins: [Table],

        props: ['applicationIdParam', 'applicationTypeParam', 'tabParam'],

        components: {
            OccupancyCertificates,
            AfterHoursPermits,
            Determinations,
            MiscServices,
            Inspections,
            DotPermits,
            Violations,
            Trackings,
            Filings,
            Permits,

            CreateTaskModal,
            EditTaskModal
        },

        data () {
            return {
                name: '',
                applicationId: this.applicationIdParam,
                applicationType: this.applicationTypeParam,
                currentTask: {},
                currentTab: 'filings',

                newTask: {},
                editTask: {},

                isReminderModalActive: false,
                isTimeLogModalActive: false,
                isCreateTaskModalActive: false,
                isEditTaskModalActive: false,
                isTasksTableVisible: false,
                moment,
            }
        },

        computed: {
            ...mapGetters([
                'applicationByTypeAndId',
                'tasksByApplication',
                'currentProjectId',
                'applicationName',
                'userNameById'
            ]),

            projectTaskRoute() {
                return task => {
                    return {
                        name: 'tasks.show',
                        params: {
                            slug: task.id
                        }
                    }
                }
            },

            tasks() {
                return this.tasksByApplication(this.currentProjectId, this.applicationId, this.applicationType)
            }
        },

        mounted () {
            if (this.tabParam) {
                this.currentTab = this.tabParam
            }else if (this.applicationType && this.applicationId) {
                this.showApplicationTasks(this.applicationByTypeAndId(this.applicationType, this.applicationId))
                this.currentTab = getApplicationTabNameByType(this.applicationType)
            }
        },

        methods: {
            ...mapActions({
                removeItem: 'removeTask'
            }),

            openReminderModal (task) {
                this.isReminderModalActive = true
                this.currentTask = task
            },

            getTabRoute (tabParam) {
                return { name: 'projects.show.applications.tab', params: { tabParam } }
            },

            handleTaskCreate(applicationType, applicationId) {
                this.newTask = {
                    category_id: 1,
                    application_type: applicationType,
                    application_id: applicationId,
                    project_id: this.currentProjectId
                }

                this.isCreateTaskModalActive = true
            },

            handleTaskEdit(task) {
                this.editTask = task
                this.isEditTaskModalActive = true
            },

            showApplicationTasks(application) {
                this.applicationId = application.id
                this.applicationType = application.application_type
                this.name = this.applicationName(application)
                this.isTasksTableVisible = true
            }
        },
        watch:{
            $route (to, from){
                if(to.name === 'projects.show.applications.tab'){
                  this.currentTab = to.params.tabParam
                  // this.$emit('tab-changed', this.tabParam)
                }
            }
        } 

    }
</script>
